const ImageActionTypes = {
  ADD_IMAGE: "ADD_IMAGE",
  REMOVE_IMAGE: "REMOVE_IMAGE",
  SET_SEARCH_TEXT: "SET_SEARCH_TEXT",
};

export default ImageActionTypes;
